var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:!_vm.settings.isSimuCastView ? 'container' : 'container_simulcast',staticStyle:{"padding-bottom":"calc(env(safe-area-inset-bottom, 0) + env(safe-area-inset-top, 0))"}},[_c('RouterView')],1)}
var staticRenderFns = []

export { render, staticRenderFns }